<script>
    import {
        Block,
        Checkbox,
        List,
        ListInput,
        Row,
        Col,
        Button,
        BlockTitle,
        Chip,
        ListItem,
        Link
    } from 'framework7-svelte';
    import { onMount } from 'svelte';
    import { getInfoCampo } from '../../../tools/service/general'
    let showMsgAlert=false
    let txtMsgSend='-------------------'
    let showMsgSend = false
    $: validateOnBlur = true

    let campo={
        "id":"",
        "estado":"",
        "municipio":"",
        "longitud":"",
        "latitud":"",
        "metodo":"",
        "vegetacion":"",
        "superficial":false,
        "copa":false,
        "subterraneo":false,
        "fechaini":"",
        "fechafin":"",
        "superficie":"",
        "comentarios":"",
        "responsable":"",
        "institucion":"",
        "correo":"",
        "correoCheck":""
    }
    let validate = {
        "id":{error:false,status:false},
        "estado":{error:false,status:false},
        "municipio":{error:false,status:false},
        "longitud":{error:false,status:false},
        "latitud":{error:false,status:false},
        "metodo":{error:false,status:false},
        "vegetacion":{error:false,status:false},
        "fechaini":{error:false,status:false},
        "fechafin":{error:false,status:false},
        "superficie":{error:false,status:false},
        "responsable":{error:false,status:false},
        "institucion":{error:false,status:false},
        "correo":{error:false,status:false},
        "correoCheck":{error:false,status:false}
    }
    function checkStatus(param){
      console.log(param,'check status...')
        let status=true;
        for (const property in param) {
            if(!param[property]['status']){
                status = false
                campo[property] = null
            }
        }
        if(!status){showAlert()}
        return status
    }
    function showAlert(){
            showMsgAlert=true
            validateOnBlur=false
        setTimeout(function(){
            showMsgAlert=false
            validateOnBlur=true
        }, 3000);
    }
    function showSend(){
            showMsgSend=true
            for (const property in campo) {
              if(campo[property] ==='superficial' || campo[property] ==='copa' || campo[property] ==='subterraneo'){
                campo[property] = false
              }
              campo[property] = ""
            }
            for (const property in validate) {
                validate[property]['error'] = false
                validate[property]['status'] = false
            }            
        setTimeout(function(){
            showMsgSend=false
        }, 4000);
    }
</script>
<style>
  .invalid {
    color: var(--f7-label-invalid-text-color, var(--f7-input-error-text-color));
  }
  .valid {
    border: var(--f7-checkbox-border-width) solid var(--f7-checkbox-inactive-color);
  }
  
</style>
{#if !showMsgSend}
<Block>
    <p>
     Se agradece la información que nos pueda proporcionar sobre incendios forestales reales registrados en su área de atención.
    </p>
    <strong>
      <p style="margin-top: 25px;color: var(--f7-table-footer-text-color);font-size: var(--f7-table-footer-font-size);">
          La información personal proporcionada es sólo para fines estadísticos y sigue las políticas de privacidad y protección de datos de la Conabio.
          <Link style="margin-top: 15px;"
          iconSize="18px"
          tooltip="{`
              <span style="color:white">Aviso de privacidad</span>
          `}"
          iconIos="f7:info_circle_fill" iconAurora="f7:info_circle_fill" iconMd="f7:info_circle_fill"
          on:click={()=>{
              window.open("https://www.biodiversidad.gob.mx/conabio/proteccion-DP/ap-proteccion-datos","","titlebar=no");
          }}/>
      </p>
    </strong>
    <List inlineLabels noHairlinesMd>
      <ListInput
        label="Id"
        type="text"
        bind:value={campo.id}
        required
        validate
        errorMessage="Completa este campo"
        errorMessageForce={validate.id.error}
        onInput={() => validate.id.error = false }
        onValidate={(isValid) => validate.id.status=isValid}
        placeholder="Ingresa la institución"
        clearButton
      >
      </ListInput>
      <ListInput
        label="Estado"
        type="text"
        bind:value={campo.estado}
        required
        validate
        errorMessage="Completa este campo"
        errorMessageForce={validate.estado.error}
        onInput={() => validate.estado.error = false }
        onValidate={(isValid) => validate.estado.status=isValid}
        placeholder="Ingresa la institución"
        clearButton
      >
      </ListInput>
      <ListInput
        label="Municipio"
        type="text"
        bind:value={campo.municipio}
        required
        validate
        errorMessage="Completa este campo"
        errorMessageForce={validate.municipio.error}
        onInput={() => validate.municipio.error = false }
        onValidate={(isValid) => validate.municipio.status=isValid}
        placeholder="Ingresa la institución"
        clearButton
      >
      </ListInput>
      <ListInput
        label="Longitud"
        type="text"
        bind:value={campo.longitud}
        required
        pattern="^[+-]?\b([0-9]?[0-7]?[0-9](\.\d+)?|180)\b"
        validate
        errorMessage="Formato incorecto"
        errorMessageForce={validate.longitud.error}
        onInput={(e) => {
          validate.longitud.error = false 
          function isLongitud(lat) {
            return isFinite(lat) && Math.abs(lat) <= 180;
          }
          if(!isLongitud(e.target.value)){
            validate.longitud.error = true
          }
          }}
        onValidate={(isValid) => validate.longitud.status=isValid}
        placeholder="(grados decimales WGS84)"
        clearButton
      >
      </ListInput>
      <ListInput
        label="Latitud"
        type="text"
        bind:value={campo.latitud}
        required
        pattern="^[+-]?\b([0-9]?[0-7]?[0-9](\.\d+)?|90)\b"
        validate
        errorMessage="Formato incorecto"
        errorMessageForce={validate.latitud.error}
        onInput={(e) => {
          validate.latitud.error = false 
          function isLatitud(lat) {
            return isFinite(lat) && Math.abs(lat) <= 90;
          }
          if(!isLatitud(e.target.value)){
            validate.latitud.error = true
          }
          }}
        onValidate={(isValid) => validate.latitud.status=isValid}
        placeholder="(grados decimales WGS84)"
        clearButton
      >
      </ListInput>
      <ListInput
        type="text"
        bind:value={campo.metodo}
        required
        validate
        errorMessage="Completa este campo"
        errorMessageForce={validate.metodo.error}
        onInput={() => validate.metodo.error = false }
        onValidate={(isValid) => validate.metodo.status=isValid}
        placeholder="Ingresa el método"
        clearButton
      >
      <div slot="label">Método de obtención<br>de coordenadas</div>
      </ListInput>
      <ListInput
          label="Tipo de vegetación"
          bind:value={campo.vegetacion}
          required
          validate
          errorMessage="Completa este campo"
          errorMessageForce={validate.vegetacion.error}
          onInput={() => validate.vegetacion.error = false }
          onValidate={(isValid) => validate.vegetacion.status=isValid}
          placeholder="Ingresa el tipo de vegetación"
          clearButton
      >
      </ListInput>
      <li>
        <p style="color: rgba(255, 255, 255, 0.54);margin-left: 17px;">Incendio Superficial 
          <Checkbox 
            style="margin-left: 74px;" 
            name="checkbox-1"
            onChange={(e) => {
              campo.superficial=e.target.checked
              }}
            >
          </Checkbox>
      </li>
      <li>
        <p style="color: rgba(255, 255, 255, 0.54);margin-left: 17px;">Incendio en Copa 
          <Checkbox 
            style="margin-left: 88px;" 
            name="checkbox-2"
            onChange={(e) => {
              campo.copa=e.target.checked
              }}
            >
          </Checkbox>
      </li>
      <li>
        <p style="color: rgba(255, 255, 255, 0.54);margin-left: 17px;">Incendio Subterraneo 
          <Checkbox 
            style="margin-left: 60px;" 
            name="checkbox-3"
            onChange={(e) => {
              campo.subterraneo=e.target.checked
              }}
            >
          </Checkbox>
      </li>

      <ListInput
        label="Fecha de Inicio"
        type="date"
        id="fechaIni"
        bind:value={campo.fechaini}
        required
        validate
        errorMessage="Completa este campo"
        errorMessageForce={validate.fechaini.error}
        onInput={() => validate.fechaini.error = false }
        onValidate={(isValid) => validate.fechaini.status=isValid}
        clearButton
      >
      </ListInput>

      <ListInput
        label="Fecha de Término"
        type="date"
        bind:value={campo.fechafin}
        required
        validate
        errorMessage="Completa este campo"
        errorMessageForce={validate.fechafin.error}
        onInput={() => validate.fechafin.error = false }
        onValidate={(isValid) => validate.fechafin.status=isValid}
        clearButton
      >
      </ListInput>
      <ListInput
        label="Superficie afectada"
        type="select"
        bind:value={campo.superficie}
        required
        validate
        errorMessage="Completa este campo"
        errorMessageForce={validate.superficie.error}
        onInput={() => validate.superficie.error = false }
        onValidate={(isValid) => validate.superficie.status=isValid}
        placeholder="Elegir una opción..."
      >
        <option value="">seleccionar</option>
        <option value="sup1">de 0 a 10 Ha</option>
        <option value="sup2">de 10 a 100 Ha</option>
        <option value="sup3">mas de 100 Ha</option>
      </ListInput>
      <ListInput
        label="Comentarios"
        type="textarea"
        bind:value={campo.comentarios}
        placeholder=""
        clearButton
      >
      </ListInput>
      <ListInput
        type="text"
        bind:value={campo.responsable}
        required
        validate
        errorMessage="Completa este campo"
        errorMessageForce={validate.responsable.error}
        onInput={() => validate.responsable.error = false }
        onValidate={(isValid) => validate.responsable.status=isValid}
        placeholder="Ingresa el método"
        clearButton
      >
      <div slot="label">Nombre del responsable<br>de la información</div>
      </ListInput>
      <ListInput
        label="Nombre de la institución"
        type="text"
        bind:value={campo.institucion}
        required
        validate
        errorMessage="Completa este campo"
        errorMessageForce={validate.institucion.error}
        onInput={() => validate.institucion.error = false }
        onValidate={(isValid) => validate.institucion.status=isValid}
        placeholder="Ingresa el método"
        clearButton
      >
      </ListInput>
      <ListInput
      label="Correo"
      type="email"
      bind:value={campo.correo}
      required
      validate
      errorMessage="Completa este campo"
      errorMessageForce={validate.correo.error}
      onInput={() => validate.correo.error = false }
      onValidate={(isValid) => validate.correo.status=isValid}
      placeholder="Ingresa el correo"
      clearButton
      >
      
      </ListInput>
      <ListInput
      label="Confirmar Correo"
      type="email"
      bind:value={campo.correoCheck}
      required
      validate
      errorMessage={validate.correoCheck.msg}
      errorMessageForce={validate.correoCheck.error}
      onInput={(val) => {
          validate.correoCheck.error = false
          }}
      validateOnBlur={validateOnBlur}
      onBlur={(val) => {
              validate.correoCheck.error = false
              validate.correoCheck.msg=""

              if(campo.correo!==campo.correoCheck){
                  validate.correoCheck.error = true
                  validate.correoCheck.msg="correo no coincide"
              }
          }}
      onValidate={(isValid) => validate.correoCheck.status=isValid}
      placeholder="Ingresa el correo"
      clearButton
      >
      </ListInput>
    </List>
  </Block>
  <Block>
    {#if showMsgAlert}
    <Row style="text-align: center;">               
        <Col >
            <Chip text="Por favor ingresa los datos faltantes" color="red" />    
        </Col>
    </Row>
    {:else}
    <Row>
        <Col>
        </Col>
        <Col>
        <Button outline
        on:click={async ()=>{
            let result={}
            console.log(checkStatus(validate),'resultado...')
            if(checkStatus(validate)){
                result = await getInfoCampo(campo)
                txtMsgSend=result.msg
                showSend()
            }
        }}
        >Enviar</Button>
        </Col>
        <Col>
        </Col>
    </Row>
    {/if}
</Block>
<Block>
    <p>La información proporcionada por esta vía será enviada directamente al equipo de Alerta Temprana de Incendios de la Conabio.</p>
</Block>
{:else}
    <BlockTitle> Mensaje Enviado </BlockTitle>
    <Block>
        <Row>               
            <Col>
                <p>{txtMsgSend}</p>    
            </Col>
        </Row>
    </Block>

{/if}